import { ICartProduct } from "../store/orders/repository/ICartProduct";

const DISCOUNT_MANUFACTURERS = ["AMS", "Teyes", "Sigma", "Ddpai", "Fort"];
const CURRENCY = {
  YE: "y.e.",
  GRN: "грн",
  USD: "usd",
  EURO: "euro",
};

export function calculateCartTotals(items: ICartProduct[]) {
  const { grnItems, yeItems, usdItems, euroItems } = splitByCurrency(items);

  const grnDiscountItems = filterByManufacturers(
    grnItems,
    DISCOUNT_MANUFACTURERS,
    true,
  );
  const grnNonDiscountItems = filterByManufacturers(
    grnItems,
    DISCOUNT_MANUFACTURERS,
    false,
  );

  const yeDiscountItems = filterByManufacturers(
    yeItems,
    DISCOUNT_MANUFACTURERS,
    true,
  );
  const yeNonDiscountItems = filterByManufacturers(
    yeItems,
    DISCOUNT_MANUFACTURERS,
    false,
  );

  const usdDiscountItems = filterByManufacturers(
    usdItems,
    DISCOUNT_MANUFACTURERS,
    true,
  );
  const usdNonDiscountItems = filterByManufacturers(
    usdItems,
    DISCOUNT_MANUFACTURERS,
    false,
  );

  const euroDiscountItems = filterByManufacturers(
    euroItems,
    DISCOUNT_MANUFACTURERS,
    true,
  );

  const euroNonDiscountItems = filterByManufacturers(
    euroItems,
    DISCOUNT_MANUFACTURERS,
    false,
  );

  return {
    grn: {
      discount: calculateTotal(grnDiscountItems),
      nonDiscount: calculateTotal(grnNonDiscountItems),
    },
    ye: {
      discount: calculateTotal(yeDiscountItems),
      nonDiscount: calculateTotal(yeNonDiscountItems),
    },
    usd: {
      discount: calculateTotal(usdDiscountItems),
      nonDiscount: calculateTotal(usdNonDiscountItems),
    },
    euro: {
      discount: calculateTotal(euroDiscountItems),
      nonDiscount: calculateTotal(euroNonDiscountItems),
    },
  };
}

function splitByCurrency(items: ICartProduct[]) {
  const grnItems: ICartProduct[] = [];
  const yeItems: ICartProduct[] = [];
  const usdItems: ICartProduct[] = [];
  const euroItems: ICartProduct[] = [];

  items.forEach((item) => {
    switch (item?.product?.currency) {
      case CURRENCY.GRN:
        grnItems.push(item);
        break;
      case CURRENCY.YE:
        yeItems.push(item);
        break;
      case CURRENCY.USD:
        usdItems.push(item);
        break;
      case CURRENCY.EURO:
        euroItems.push(item);
        break;
    }
  });

  return { grnItems, yeItems, usdItems, euroItems };
}

function filterByManufacturers(
  items: ICartProduct[],
  manufacturers: string[],
  include: boolean,
): ICartProduct[] {
  const lowerManufacturers = manufacturers.map((m) => m.toLowerCase());

  return items.filter((item) => {
    const manufacturerName = (
      item.product.manufacturer?.name || ""
    ).toLowerCase();
    return include
      ? lowerManufacturers.includes(manufacturerName)
      : !lowerManufacturers.includes(manufacturerName);
  });
}

function calculateTotal(items: ICartProduct[]): number {
  return items.reduce(
    (total, item) => total + item.amount * item.product.price,
    0,
  );
}
